import { defineComponent as _defineComponent } from 'vue'
import {
  DocumentExportOptions,
  DocumentExportFormat,
  NotificationEventType,
  NotificationType,
  VanillaPriceResponse,
} from 'ah-api-gateways';
import { downloadBlob } from 'ah-common-lib/src/helpers/download';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { reactive, computed, watch } from 'vue';
import { useAhTradesState } from '..';
import { mergeMap, filter, take, map } from 'rxjs/operators';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionTermsheetViewer',
  props: {
    solution: null
  },
  emits: ["error"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'error', value: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { solution: VanillaPriceResponse };



const tradeState = useAhTradesState();

const exportOptionsParam: DocumentExportOptions = {
  fileFormat: DocumentExportFormat.PDF,
  documentTitle: 'Termsheet',
  backgroundExport: true,
};



const notificationsStore = tradeState.store.useNotificationsStore();

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadTermsheet') {
      loadSolutionTermsheet();
    }
  },
}).manager;

const state = reactive<{
  termsheetUrl: string | null;
  file: Blob | null;
}>({
  termsheetUrl: null,
  file: null,
});

const hasLoadError = computed(() => requestManager.requestStates.loadTermsheet === 'error');

const isSafari = computed(() => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
});

const termsheetIframeUrl = computed(() => `${state.termsheetUrl}${isSafari.value ? '' : '#toolbar=0'}`);

/**
 * This function is requesting a vanilla options termsheet.
 * After the request is made we are watching the notificationEvents until we receive a notification saying that the file is ready.
 * We use the data received by the notification center to then synchronously request the document.
 */
function loadSolutionTermsheet() {
  requestManager
    .sameOrCancelAndNew(
      'loadTermsheet',
      tradeState.services.termsheetService
        .exportVanillaOptionsTermsheet(props.solution.id, props.solution.premiumCurrency!, exportOptionsParam)
        .pipe(
          mergeMap((doc) =>
            // We filter the notifications by resource id (as to match the document id) and with the correct types that enable download
            notificationsStore.notificationEvents.pipe(
              filter(
                (notif) =>
                  notif.eventType === NotificationEventType.NOTIFICATION_CREATED &&
                  notif.payload.resource === doc.id &&
                  notif.payload.type === NotificationType.DOCUMENT_STATUS_EXPORTED
              ),
              // take returns an Observable that emits only the first count values
              take(1),
              // returns the notification
              map(() => doc)
            )
          ),
          mergeMap((doc) =>
            // request the document with the data received by the notification center
            tradeState.services.documents.getSyncDocument(doc.type, doc.id, {
              axiosConfig: { headers: { Accept: 'application/pdf' } },
            })
          )
        )
    )
    .subscribe(
      (doc) => {
        state.file = new Blob([doc.data as any as BlobPart], { type: 'application/pdf' });
        state.termsheetUrl = URL.createObjectURL(state.file);
      },
      (e) => {
        emit('error', e);
      }
    );
}

watch(
  () => props.solution,
  () => loadSolutionTermsheet(),
  { immediate: true }
);

function downloadPDF() {
  if (state.file) {
    downloadBlob(state.file, 'termsheet.pdf');
  }
}

return { __sfc: true,props, tradeState, exportOptionsParam, emit, notificationsStore, requestManager, state, hasLoadError, isSafari, termsheetIframeUrl, loadSolutionTermsheet, downloadPDF }
}

})